import { render } from "./BaseBox.vue?vue&type=template&id=64fa3d9f"
import script from "./BaseBox.vue?vue&type=script&lang=js"
export * from "./BaseBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64fa3d9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64fa3d9f', __exports__)) {
    console.log('reload')
    api.reload('64fa3d9f', __exports__)
  }
  
  module.hot.accept("./BaseBox.vue?vue&type=template&id=64fa3d9f", () => {
    console.log('re-render')
    api.rerender('64fa3d9f', render)
  })

}


export default __exports__